import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, message , theme, Row, Divider, InputNumber, Checkbox} from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function SellLatexModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages] = useState(null);

  useEffect(() => {
    if(open){
      form.resetFields();
      if (target) {
        form.setFieldsValue(target);
      }
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();


  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SETTING.SELLER_RAW_LATEX}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.SELLER_RAW_LATEX, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขผู้ขายน้ำยางสด" : "เพิ่มผู้ขายน้ำยางสด"}
      width={650}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/> 
        <Form form={form} layout="vertical">
          <Row gutter={10}>
            <Col span={10}>
              <Form.Item
                label="รหัส (Code)"
                name="code"
                rules={[{ required: true, message: "กรุณากรอก Code" }]}
              >
                <Input placeholder="รหัส"/>
              </Form.Item>
            </Col>

            <Col span={14}>
              <Form.Item
                label="ชื่อลูกค้า"
                name="name"
                rules={[{ required: true, message: "กรุณากรอกชื่อลูกค้า" }]}
              >
                <Input placeholder="ชื่อลูกค้า"/>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="ที่อยู่"
                name="address"
                rules={[{ required: true, message: "กรุณากรอกที่อยู่" }]}
              >
                <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="ที่อยู่"/>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="บัญชีธนาคาร"
                name="bank_name"
              >
                <Input placeholder="บัญชีธนาคาร"/>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="เลขที่บัญชี"
                name="bank_account_number"
              >
                <Input placeholder="เลขที่บัญชี"/>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="โค้วต้า"
                name="quota"
              >
                <InputNumber style={{width : '100%'}} placeholder="โค้วต้า"/>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="หมายเหตุ"
                name="note"
              >
                <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="หมายเหตุ"/>
              </Form.Item>
            </Col>

            <Form.Item
              name="is_juristic"
              valuePropName="checked"
              style={{ marginLeft : 7}}
            >
              <Checkbox>เป็นนิติบุคคล</Checkbox>
            </Form.Item>

            <Divider>ข้อมูลผู้ติดต่อ</Divider>

            <Col span={14}>
              <Form.Item
                label="ชื่อผู้ติดต่อ"
                name="contact"
                rules={[{ required: true, message: "กรุณากรอกชื่อผู้ติดต่อ" }]}
              >
                <Input placeholder="ชื่อผู้ติดต่อ"/>
              </Form.Item>
            </Col>

            <Col span={10}>
              <Form.Item
                label="เบอร์โทรติดต่อ"
                name="phone"
                rules={[
                  {
                    pattern: /^[0-9]{9,10}$/,
                    message: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง (9-10 ตัวเลข)",
                  },
                ]}
              >
                <Input placeholder="เบอร์โทรติดต่อ"/>
              </Form.Item>
            </Col>
            
            <Col span={24}>
            <Form.Item
              label="ค่าบรรทุก"
              name="wage"
            >
              <Input placeholder="ค่าบรรทุก" autoComplete="off"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
